
import { Component, Prop, Vue, Watch } from 'vue-facing-decorator'
import { Action, State } from 'vuex-facing-decorator';
import { ListViewVue } from '@/common/BaseVue'
import CreateShop from './com/create-shop.vue'
import ChangePwd from './com/change-pwd.vue'
import NotifySetting from './com/notify-setting.vue'

@Component({})
export default class extends ListViewVue {
  listType = "router";

  @State("user", {
    namespace: "user"
  })
  userInfo;

  @Action('user/logout')
  userLogout;

  async getList() {
    return this.$post("/manager/store/list", { ...this.mesureData });
  }

  async createShop() {
    await this.$dialog({
      props: {
        width: 600
      },
      content: () => {
        return <CreateShop />
      }
    })
    this.$success('创建成功')
    this.refresh()
  }

  @Action("user/getUserInfo")
  getUserInfo;

  created() {
    this.getUserInfo()

  }
  async notifySetting() {
    /**
     * 点右上角关闭走的是 reject，不接就是一条 unhandled rejection。
     * 另外这个弹窗保存成功后会 resolve、测试成功则一直开着，所以不能像
     * changePwd 那样 await 完就无条件做后续动作
     * */
    await this.$dialog({
      props: {
        /** 窄屏也要能完整看到，宽度跟着视口收 */
        width: 'min(800px, 92vw)',
        /**
         * el-dialog 默认 top 是 15vh（--el-dialog-margin-top），而全局样式把
         * .el-overlay-dialog 改成了 flex 居中：两下一叠加，弹窗会被这个上边距
         * 整体推下去，底部空间白白浪费。归零交给 flex 居中，高度再自己封顶
         * （见 notify-setting.vue 的 .notify-setting-box），才不会溢出到看不见标题
         * */
        top: '0'
      },
      content: () => {
        return <NotifySetting />
      }
    }).catch(() => { })
  }

  gotoManager() {
    location.href = '/manager'
  }

  handleCommand(command) {
    this[command] && this[command]();
  }
  async logout() {
    await this.userLogout()
  }

  async changePwd() {
    await this.$dialog({
      props: {
        width: '600px'
      },
      content: () => {
        return <ChangePwd />
      }
    })
    await this.$sleep(500);
    await this.userLogout({
      needRquest: false,
      tooltip: false,
    })
  }
  gotoIndex(storeId) {
    this.$chooseStore(storeId);
    /** 整页刷新：菜单和店铺信息在 store 模块里按 module 级变量缓存，SPA 内跳转拿到的还是上一个店铺的 */
    location.href = "/";
  }
}
